// import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
// import ArrowDropDownOutlinedIcon from "@mui/icons-material/ArrowDropDownOutlined";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import SearchIcon from "@mui/icons-material/Search";
// import LogoutIcon from "@mui/icons-material/Logout";
// import { allItems } from "../../constants";
import { logo } from "../../assets/index";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";
import { userSignOut } from "../../redux/amazonSlice";
import React, { useEffect } from "react";
// import "./Header.css";

import "./Header.css";
// import axios from "axios";

import "boxicons/css/boxicons.min.css";
import { useState } from "react";
import UserDetails from "./UserDetails";
import ProductDetail from "../home/ProductDetail";
import Example, { DrawOutlineButton } from "../ui/DrawOutlineButton";
import Head from "./Head";

const links = [
  "Percussion",
  "Wind",
  "Strings",
  "Keyboard",
  "Traditional",
  "Tutorials",
  "courses",
  "MusicClasses",
  "music",
  "OnlineTutor",
];

const Header = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const [active, setActive] = useState("");
  const navigate = useNavigate();

  const handleFilter = (link) => {
    setActive(link);
    navigate(`/categories/${link}`);
  };

  const products = useSelector((state) => state.amazonReducer.products);
  const userInfo = useSelector((state) => state.amazonReducer.userInfo);
  const items = useSelector((state) => state.amazonReducer.items);

  // console.log(items);

  const dispatch = useDispatch();

  const auth = getAuth();

  // const ref = useRef();
  // const [showAll, setShowAll] = useState(false);

  const handleLogout = () => {
    signOut(auth)
      .then(() => {
        // Sign-out successful.
        console.log("sign out succesfully");
        dispatch(userSignOut());
        setShowUserDetails(!showUserDetails);
      })
      .catch((error) => {
        // An error happened.
      });
  };

  const location = useLocation();

  React.useEffect(() => {
    if (location.pathname === "/") {
      setActive("");
    }
  }, [location]);

  // console.log(userInfo)

  const [showUserDetails, setShowUserDetails] = useState(false);
  // Function to toggle user details popup visibility
  const toggleUserDetails = (event) => {
    event.preventDefault(); // Prevent the default navigation behavior
    setShowUserDetails(!showUserDetails);
  };

  //search bar
  const [search, setSearch] = useState(false);

  const handleSearchInputChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // const handleSearch = async () => {
  //   try {
  //     const response = await axios.get(
  //       `https://snk-music-store-backend.cyclic.app/search?term=${searchTerm}`
  //     );

  //     setSearchResults(response.data);
  //     // console.log(response.data);
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  useEffect(() => {
    const handleSearch = () => {
      try {
        if (searchTerm.trim() !== "") {
          // Check if searchTerm is not empty or only whitespace
          // Assuming itemsList is an array containing all the products
          const searchResults = items.filter((product) => {
            const regex = new RegExp(searchTerm, "i");
            // Check if the product title or description matches the search term
            return regex.test(product.title) || regex.test(product.description);
          });

          setSearchResults(searchResults);
          // console.log(searchResults);
        } else {
          // If searchTerm is empty, reset searchResults to an empty array or initial state
          setSearchResults([]);
        }
      } catch (error) {
        console.error(error);
      }
    };

    handleSearch();
  }, [searchTerm, items]);

  const [showProductDetail, setShowProductDetail] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null); // Local state to store the selected product
  // console.log(selectedProduct);

  const hideDetails = () => {
    setSelectedProduct(null);
    setShowProductDetail(false);
  };
  window.addEventListener("scroll", function () {
    const search = document.querySelector(".header");
    search.classList.toggle("active", window.scrollY > 10);
  });

  return (
    <div>
      <Head />
      <div className="header sticky top-0 z-50">
        <div className="  w-full bg-amazon_blue text-white px-4 py-3 flex md:justify-between items-center gap-2 md:gap-4 lgl:gap-2 xl:gap-4">
          {/* ===================== Header Image Start here ======================== */}
          <Link to="/" onClick={() => setActive("")}>
            <div className="headerHover">
              <img className="w-24 mt-2" src={logo} alt="logoImage" />
            </div>
          </Link>
          {/* ===================== Header Image End here ========================== */}
          {/* ===================== Header Deliver Start here ====================== */}
          <div className="hidden md:inline-flex headerHover">
            <LocationOnOutlinedIcon />
            <p className="flex flex-col text-xs text-lightText font-light">
              Shipping to{" "}
              <span className="text-sm font-semibold -mt-1 text-whiteText">
                Music Lovers
              </span>
            </p>
          </div>
          {/* ===================== Header Deliver End here ======================== */}
          {/* ===================== Header Search Start here ======================== */}
          <div className="hidden lgl:inline-flex h-10 rounded-md flex-grow relative">
            <span
              // onClick={() => setShowAll(!showAll)}
              className="w-8 h-full bg-gray-200 hover:bg-gray-300 border-2 cursor-pointer duration-300 text-sm text-amazon_blue font-titleFont flex items-center justify-center rounded-tl-md rounded-bl-md"
            >
              <span>{/* <ArrowDropDownOutlinedIcon /> */}</span>
            </span>
            {/* {showAll && (
            <div>
              <ul

                className="absolute w-56 h-80 top-10 left-0 overflow-y-scroll overflow-x-hidden bg-white border-[1px] border-amazon_blue text-black p-2 flex flex-col gap-1 z-50"
              >
                {allItems.map((item) => (
                  <li
                    className="text-sm tracking-wide font-titleFont border-b-[1px] border-b-transparent hover:border-b-amazon_blue cursor-pointer duration-200"
                    key={item._id}
                  >
                    {item.title}
                  </li>
                ))}
              </ul>
            </div>
          )} */}

            <input
              className="h-full text-base text-amazon_blue flex-grow outline-none border-none px-2"
              type="text"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <span
              className="w-12 h-full flex items-center justify-center bg-blue-400 hover:bg-blue-600 active:bg-blue-900 duration-300 text-amazon_blue cursor-pointer rounded-tr-md rounded-br-md"
              // onClick={handleSearch}
            >
              <SearchIcon />
            </span>
          </div>
          <div
            onClick={() => setSearch(!search)}
            className="lg:hidden ml-6 pt-1"
          >
            <SearchIcon style={{ fontSize: 30 }} />
          </div>
          {/* ===================== Header Search End here ========================== */}
          {/* ===================== Header Signin Start here ======================== */}
          {/* <Link to="/signin">
          <div className="flex flex-col items-start justify-center headerHover">
            {userInfo ? (
              <p className="text-sm text-lightText font-light">
                {userInfo.userName}
              </p>
            ) : (
              <p className="text-xs text-gray-100 font-medium">
                Hello, sign in
              </p>
            )}

            <p className="hidden md:inline-flex text-sm font-semibold -mt-1 text-whiteText">
              Accounts & Lists{" "}
              <span>
                <ArrowDropDownOutlinedIcon />
              </span>
            </p>
          </div>
        </Link> */}
          {userInfo ? (
            <div className="ml-10 mt-1 lg:mt-0 md:ml-0">
              <img
                className=" w-9 md:w-8 h-8 rounded-full"
                src={userInfo.image}
                alt="Altimage"
                onClick={toggleUserDetails}
              />
            </div>
          ) : (
            <Link
              to="/signin"
              className="ml-7 mt-1 lg:mt-0 md:ml-0 text-sm text-gray-100 font-medium"
            >
              <Example />
            </Link>
          )}

          {/* Conditionally render the UserDetails component */}
          {showUserDetails && userInfo && (
            <UserDetails
              userInfo={userInfo}
              handleLogout={handleLogout}
              onClose={toggleUserDetails}
            />
          )}

          {/* Apply the overlay class conditionally */}
          {showUserDetails && (
            <div className="overlay fixed inset-0 bg-black opacity-50 z-40"></div>
          )}
          {/* ===================== Header Signin End here ========================== */}
          {/* ===================== Header Orders Start here ======================== */}
          <div className="hidden mdl:flex flex-col items-start justify-center headerHover">
            <p className="text-xs text-lightText font-light">Refunds</p>
            <p className="text-sm font-semibold -mt-1 text-whiteText">
              &Exchanges
            </p>
          </div>
          {/* ===================== Header Orders End here ========================== */}
          {/* ===================== Header Cart Start here ========================== */}
          <DrawOutlineButton>
            <Link
              to="/cart"
              className="ml-10 mt-1 mr-2 lg:mr-0 lg:mt-0 md:ml-0"
            >
              <div className="flex  items-start justify-center headerHover relative">
                <ShoppingCartIcon />
                <p className="hidden mdl:inline-flex text-xs font-semibold mt-3 text-whiteText">
                  Cart
                </p>
                <span className="absolute text-xs top-0 left-6 w-4 font-semibold p-1 h-4 bg-blue-400  hover:bg-blue-600 active:bg-blue-900 text-amazon_blue rounded-full flex justify-center items-center">
                  {products.length > 0 ? products.length : 0}
                </span>
              </div>
            </Link>
          </DrawOutlineButton>

          {/* <Link to="/cart" className="ml-12 md:ml-0">
          <div className="flex  items-start justify-center headerHover relative">
            <ShoppingCartIcon />
            <p className="hidden mdl:inline-flex text-xs font-semibold mt-3 text-whiteText">
              Cart
            </p>
            <span className="absolute text-xs top-0 left-6 w-4 font-semibold p-1 h-4 bg-blue-400  hover:bg-blue-600 active:bg-blue-900 text-amazon_blue rounded-full flex justify-center items-center">
              {products.length > 0 ? products.length : 0}
            </span>
          </div>
        </Link> */}
          {/* {userInfo && (
          <div
            onClick={handleLogout}
            className="flex ml-12 md:ml-0 flex-col justify-center items-center headerHover relative cursor-pointer"
          >
            <LogoutIcon />
            <p className="hidden mdl:inline-flex text-xs font-semibold text-whiteText">
              Log out
            </p>
          </div>
        )} */}
        </div>
        {search && (
          <div className="flex bg-gray-100 p-3 z-50">
            <input
              className="h-full text-base text-amazon_blue flex-grow outline-none border-none px-3 py-1"
              type="text"
              placeholder="Search"
              value={searchTerm}
              onChange={handleSearchInputChange}
            />
            <span
              className="w-12 h-full flex items-center justify-center bg-blue-400 hover:bg-blue-600 active:bg-blue-900 duration-300 text-amazon_blue cursor-pointer rounded-tr-md rounded-br-md py-1"
              // onClick={handleSearch}
            >
              <SearchIcon />
            </span>
          </div>
        )}

        {showProductDetail && (
          <ProductDetail
            product={selectedProduct}
            onClose={hideDetails} // Pass onClose function to close ProductDetail
          />
        )}
        <div className="text-center bg-blue-950">
          <ul className="text-white body-text no-scrollbar flex w-full max-w-full overflow-auto sm:max-w-full">
            {links.map((link) => (
              <button
                key={link}
                onClick={() => handleFilter(link)}
                className={`${
                  active === link ? " underline" : ""
                } whitespace-nowrap rounded-lg px-[27px] py-2.5 capitalize`}
              >
                {link}
              </button>
            ))}
          </ul>
        </div>
        {searchResults.length > 0 && (
          <div className="flex justify-center absolute top-[126px] lg:top-[55px] left-0 right-0 mx-auto max-w-[1000px] w-full z-100">
            {" "}
            <div className=" bg-white rounded-md shadow-md p-3 px-20">
              {searchResults.map((result) => (
                <div key={result._id} className=" border-b border-gray-200 m-2">
                  <Link
                    to={`/productDetails/${result.id}`}
                    onClick={() => setSearchResults([])}
                    // onClick={() => {
                    //   setShowProductDetail(true);
                    //   setSelectedProduct(result);
                    // }}
                    className="flex items-center"
                  >
                    <img
                      src={result.image}
                      alt={result.title}
                      className="h-10 w-10 object-contain"
                    />
                    <h3 className="text-base ">{result.title}</h3>
                  </Link>
                </div>
              ))}
            </div>
            <button
              className=" text-red-600 text-[30px] h-10 bg-gray-200 px-4 rounded-full"
              onClick={() => setSearchResults([])}
            >
              X
            </button>
          </div>
        )}
        {/* {searchResults.length > 0 && (
        <div className="flex justify-center absolute top-16 lg:top-12 left-0 right-0 mx-auto max-w-screen-xl w-full z-50">
          <div className="bg-white rounded-md shadow-md p-2 lg:p-3 w-full max-w-xl">
            {searchResults.map((result) => (
              <div key={result._id} className="border-b border-gray-200 py-2">
                <button
                  onClick={() => {
                    setShowProductDetail(true);
                    setSelectedProduct(result);
                  }}
                  className="flex items-center space-x-2 hover:text-blue-600 focus:outline-none"
                >
                  <img
                    src={result.image}
                    alt={result.title}
                    className="h-12 w-12 object-contain"
                  />
                  <h3 className="text-base lg:text-lg font-semibold">
                    {result.title}
                  </h3>
                </button>
              </div>
            ))}
          </div>
          <button
            className="absolute top-0 right-0 mt-1 mr-1 text-red-600 text-lg bg-gray-200 px-2 py-1 rounded-full hover:bg-gray-300 focus:outline-none"
            onClick={() => setSearchResults([])}
          >
            X
          </button>
        </div>
      )} */}
      </div>
    </div>
  );
};

export default Header;

// // import React, { useEffect, useRef, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
// // import ArrowDropDownOutlinedIcon from "@mui/icons-material/ArrowDropDownOutlined";
// import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
// import SearchIcon from "@mui/icons-material/Search";
// // import LogoutIcon from "@mui/icons-material/Logout";
// // import { allItems } from "../../constants";
// import { logo } from "../../assets/index";
// import { Link, useNavigate, useLocation } from "react-router-dom";
// import { getAuth, signOut } from "firebase/auth";
// import { userSignOut } from "../../redux/amazonSlice";
// import React from "react";
// import "./Header.css";

// import "./Header.css";

// import "boxicons/css/boxicons.min.css";
// import { useState } from "react";
// import UserDetails from "./UserDetails";

// const links = [
//   "Percussion",
//   "Wind",
//   "Strings",
//   "Keyboard",
//   "Traditional",
//   "Tutorials",
// ];

// const Header = () => {
//   const [active, setActive] = useState("");
//   const navigate = useNavigate();

//   const handleFilter = (link) => {
//     setActive(link);
//     navigate(`/categories/${link}`);
//   };

//   const products = useSelector((state) => state.amazonReducer.products);
//   const userInfo = useSelector((state) => state.amazonReducer.userInfo);

//   const dispatch = useDispatch();

//   const auth = getAuth();

//   // const ref = useRef();
//   // const [showAll, setShowAll] = useState(false);

//   const handleLogout = () => {
//     signOut(auth)
//       .then(() => {
//         // Sign-out successful.
//         console.log("sign out succesfully");
//         dispatch(userSignOut());
//         setShowUserDetails(!showUserDetails);
//       })
//       .catch((error) => {
//         // An error happened.
//       });
//   };

//   const location = useLocation();

//   React.useEffect(() => {
//     if (location.pathname === "/") {
//       setActive("");
//     }
//   }, [location]);

//   // console.log(userInfo)

//   const [showUserDetails, setShowUserDetails] = useState(false);
//   // Function to toggle user details popup visibility
//   const toggleUserDetails = (event) => {
//     event.preventDefault(); // Prevent the default navigation behavior
//     setShowUserDetails(!showUserDetails);
//   };

//   //search bar
//   const [search, setSearch] = useState(false);
//   return (
//     <div className="sticky top-0 z-50">
//       <div className="w-full bg-amazon_blue text-white px-4 py-3 flex md:justify-between items-center gap-2 md:gap-4 lgl:gap-2 xl:gap-4">
//         {/* ===================== Header Image Start here ======================== */}
//         <Link to="/" onClick={() => setActive("")}>
//           <div className="headerHover">
//             <img className="w-24 mt-2" src={logo} alt="logoImage" />
//           </div>
//         </Link>
//         {/* ===================== Header Image End here ========================== */}
//         {/* ===================== Header Deliver Start here ====================== */}
//         <div className="hidden md:inline-flex headerHover">
//           <LocationOnOutlinedIcon />
//           <p className="flex flex-col text-xs text-lightText font-light">
//             Deliver to{" "}
//             <span className="text-sm font-semibold -mt-1 text-whiteText">
//               India
//             </span>
//           </p>
//         </div>
//         {/* ===================== Header Deliver End here ======================== */}
//         {/* ===================== Header Search Start here ======================== */}
//         <div className="hidden lgl:inline-flex h-10 rounded-md flex-grow relative">
//           <span
//             // onClick={() => setShowAll(!showAll)}
//             className="w-8 h-full bg-gray-200 hover:bg-gray-300 border-2 cursor-pointer duration-300 text-sm text-amazon_blue font-titleFont flex items-center justify-center rounded-tl-md rounded-bl-md"
//           >
//             <span>{/* <ArrowDropDownOutlinedIcon /> */}</span>
//           </span>
//           {/* {showAll && (
//             <div>
//               <ul

//                 className="absolute w-56 h-80 top-10 left-0 overflow-y-scroll overflow-x-hidden bg-white border-[1px] border-amazon_blue text-black p-2 flex flex-col gap-1 z-50"
//               >
//                 {allItems.map((item) => (
//                   <li
//                     className="text-sm tracking-wide font-titleFont border-b-[1px] border-b-transparent hover:border-b-amazon_blue cursor-pointer duration-200"
//                     key={item._id}
//                   >
//                     {item.title}
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           )} */}

//           <input
//             className="h-full text-base text-amazon_blue flex-grow outline-none border-none px-2"
//             type="text"
//           />
//           <span className="w-12 h-full flex items-center justify-center bg-blue-400 hover:bg-blue-600 active:bg-blue-900 duration-300 text-amazon_blue cursor-pointer rounded-tr-md rounded-br-md">
//             <SearchIcon />
//           </span>
//         </div>
//         <div onClick={() => setSearch(!search)} className="lg:hidden ml-6 pt-1">
//           <SearchIcon style={{ fontSize: 30 }} />
//         </div>
//         {/* ===================== Header Search End here ========================== */}
//         {/* ===================== Header Signin Start here ======================== */}
//         {/* <Link to="/signin">
//           <div className="flex flex-col items-start justify-center headerHover">
//             {userInfo ? (
//               <p className="text-sm text-lightText font-light">
//                 {userInfo.userName}
//               </p>
//             ) : (
//               <p className="text-xs text-gray-100 font-medium">
//                 Hello, sign in
//               </p>
//             )}

//             <p className="hidden md:inline-flex text-sm font-semibold -mt-1 text-whiteText">
//               Accounts & Lists{" "}
//               <span>
//                 <ArrowDropDownOutlinedIcon />
//               </span>
//             </p>
//           </div>
//         </Link> */}
//         {userInfo ? (
//           <div className="ml-10 mt-1 lg:mt-0 md:ml-0">
//             <img
//               className=" w-9 md:w-8 h-8 rounded-full"
//               src={userInfo.image}
//               alt="Altimage"
//               onClick={toggleUserDetails}
//             />
//           </div>
//         ) : (
//           <Link
//             to="/signin"
//             className="ml-7 mt-1 lg:mt-0 md:ml-0 text-sm text-gray-100 font-medium"
//           >
//             sign in
//           </Link>
//         )}

//         {/* Conditionally render the UserDetails component */}
//         {showUserDetails && userInfo && (
//           <UserDetails
//             userInfo={userInfo}
//             handleLogout={handleLogout}
//             onClose={toggleUserDetails}
//           />
//         )}

//         {/* Apply the overlay class conditionally */}
//         {showUserDetails && (
//           <div className="overlay fixed inset-0 bg-black opacity-50 z-40"></div>
//         )}
//         {/* ===================== Header Signin End here ========================== */}
//         {/* ===================== Header Orders Start here ======================== */}
//         <div className="hidden mdl:flex flex-col items-start justify-center headerHover">
//           <p className="text-xs text-lightText font-light">Returns</p>
//           <p className="text-sm font-semibold -mt-1 text-whiteText">& Orders</p>
//         </div>
//         {/* ===================== Header Orders End here ========================== */}
//         {/* ===================== Header Cart Start here ========================== */}
//         <Link to="/cart" className="ml-10 mt-1 mr-2 lg:mr-0 lg:mt-0 md:ml-0">
//           <div className="flex  items-start justify-center headerHover relative">
//             <ShoppingCartIcon />
//             <p className="hidden mdl:inline-flex text-xs font-semibold mt-3 text-whiteText">
//               Cart
//             </p>
//             <span className="absolute text-xs top-0 left-6 w-4 font-semibold p-1 h-4 bg-blue-400  hover:bg-blue-600 active:bg-blue-900 text-amazon_blue rounded-full flex justify-center items-center">
//               {products.length > 0 ? products.length : 0}
//             </span>
//           </div>
//         </Link>
//         {/* <Link to="/cart" className="ml-12 md:ml-0">
//           <div className="flex  items-start justify-center headerHover relative">
//             <ShoppingCartIcon />
//             <p className="hidden mdl:inline-flex text-xs font-semibold mt-3 text-whiteText">
//               Cart
//             </p>
//             <span className="absolute text-xs top-0 left-6 w-4 font-semibold p-1 h-4 bg-blue-400  hover:bg-blue-600 active:bg-blue-900 text-amazon_blue rounded-full flex justify-center items-center">
//               {products.length > 0 ? products.length : 0}
//             </span>
//           </div>
//         </Link> */}
//         {/* {userInfo && (
//           <div
//             onClick={handleLogout}
//             className="flex ml-12 md:ml-0 flex-col justify-center items-center headerHover relative cursor-pointer"
//           >
//             <LogoutIcon />
//             <p className="hidden mdl:inline-flex text-xs font-semibold text-whiteText">
//               Log out
//             </p>
//           </div>
//         )} */}
//       </div>
//       {search && (
//         <div className="flex bg-gray-100 p-3 z-50">
//           <input
//             className="h-full text-base text-amazon_blue flex-grow outline-none border-none px-3 py-1"
//             type="text"
//             placeholder="Search"
//           />
//           <span className="w-12 h-full flex items-center justify-center bg-blue-400 hover:bg-blue-600 active:bg-blue-900 duration-300 text-amazon_blue cursor-pointer rounded-tr-md rounded-br-md py-1">
//             <SearchIcon />
//           </span>
//         </div>
//       )}
//       <div className="text-center bg-blue-950">
//         <ul className="text-white body-text no-scrollbar flex  w-full max-w-full gap-2 overflow-auto sm:max-w-4xl">
//           {links.map((link) => (
//             <button
//               key={link}
//               onClick={() => handleFilter(link)}
//               className={`${
//                 active === link ? " underline" : ""
//               } whitespace-nowrap rounded-lg px-8 py-2.5 capitalize`}
//             >
//               {link}
//             </button>
//           ))}
//         </ul>
//       </div>
//     </div>
//   );
// };

// export default Header;
